import {
  Link,
  Avatar,
  Rating,
  TableRow,
  TableCell,
  Typography,
  IconButton,
  ListItemText,
} from '@mui/material';

import Iconify from 'src/components/iconify';
import Label from 'src/components/label';
import { paths } from 'src/routes/paths';
import { UserType, UserLevel, UserVerificationStatus } from 'src/type/user';
import { shortString } from 'src/utils/format-string';
import { verificationStatusLabel } from './utils';

type Props = {
  row: UserType;
};

export default function UserTableRow({ row }: Props) {
  const { firstName, lastName, uid, verifyStatus, level } = row;

  const levelCount = (lv: UserLevel) => {
    switch (lv) {
      case UserLevel.LV1:
        return 1;
      case UserLevel.LV2:
        return 2;
      case UserLevel.LV3:
        return 3;
      case UserLevel.LV4:
        return 4;
      case UserLevel.LV5:
        return 5;
      default:
        return 0;
    }
  };

  return (
    <TableRow>
      <TableCell sx={{ display: 'flex', alignItems: 'center' }}>
        <Avatar alt="" sx={{ mr: 2 }}>
          {firstName?.[0]?.toUpperCase()}
        </Avatar>

        <ListItemText
          disableTypography
          primary={
            <Typography variant="body2" noWrap>
              {firstName} {lastName}
            </Typography>
          }
          secondary={
            <Typography variant="caption" color="text.secondary" noWrap>
              #{shortString(uid)}
            </Typography>
          }
        />
      </TableCell>

      <TableCell>
        <Label variant="soft" color={row.isEnable ? 'success' : 'error'}>
          {row.isEnable ? 'ปกติ' : 'โดนแบน'}
        </Label>
      </TableCell>

      <TableCell>
        <Label
          variant="soft"
          color={
            (verifyStatus === UserVerificationStatus.VERIFIED && 'success') ||
            (verifyStatus === UserVerificationStatus.PENDING && 'info') ||
            (verifyStatus === UserVerificationStatus.PROCESSING && 'secondary') ||
            (verifyStatus === UserVerificationStatus.REJECTED && 'error') ||
            'default'
          }
        >
          {verificationStatusLabel(verifyStatus)}
        </Label>
      </TableCell>

      <TableCell>
        <Label variant="soft" color={row.isPreRegistered ? 'success' : 'default'}>
          {row.isPreRegistered ? 'ใช่' : 'ไม่'}
        </Label>
      </TableCell>

      {/* <TableCell>{userWallet?.credit ? fNumber(userWallet?.credit) : '-'}</TableCell> */}

      <TableCell>
        <Rating size="small" value={levelCount(level)} readOnly />
      </TableCell>

      <TableCell align="right" sx={{ px: 2 }}>
        <Link href={paths.management.user.edit(row.uid)}>
          <IconButton>
            <Iconify icon="solar:arrow-right-outline" />
          </IconButton>
        </Link>
      </TableCell>
    </TableRow>
  );
}
